var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStockGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.479,
    height: 40.887,
    viewBox: "0 0 28.479 40.887",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17903",
    "data-name": "Group 17903",
    transform: "translate(-2332.958 -424.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18091",
    "data-name": "Path 18091",
    d: "M2336.227,571.632l21.983.432a2.274,2.274,0,0,1,2.232,2.2l.994,31.774a1.676,1.676,0,0,1-1.682,1.725l-25.2-.039a1.591,1.591,0,0,1-1.592-1.619l.633-31.947A2.581,2.581,0,0,1,2336.227,571.632Z",
    transform: "translate(0 -141.98)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18092",
    "data-name": "Path 18092",
    d: "M2362.549,1519.659h0l-2.908-.095a1.8,1.8,0,0,1-1.735-1.828l.086-4.392a.069.069,0,0,1,.068-.067h0a.069.069,0,0,1,.067.07l-.087,4.392a1.663,1.663,0,0,0,1.6,1.688l2.908.095a.068.068,0,0,1,0,.137Z",
    transform: "translate(-24.137 -1054.396)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18093",
    "data-name": "Path 18093",
    d: "M2398.245,563.188c2.98.464,13.233,1.919,21.743,1.435a.691.691,0,0,1,.732.666l1.066,31.887a.8.8,0,0,1-.764.821c-3.578.141-18.312.668-23.55.015a.63.63,0,0,1-.552-.634l.463-33.461A.748.748,0,0,1,2398.245,563.188Z",
    transform: "translate(-61.887 -133.802)",
    fill: "#16b26e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18094",
    "data-name": "Path 18094",
    d: "M2409.5,589.829c2.864.446,12.717,1.844,20.894,1.379a.664.664,0,0,1,.7.64l1.024,30.642a.765.765,0,0,1-.734.789c-3.438.135-17.6.642-22.631.015a.606.606,0,0,1-.53-.61l.445-32.155A.718.718,0,0,1,2409.5,589.829Z",
    transform: "translate(-72.829 -159.579)",
    fill: "#97ccb2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18095",
    "data-name": "Path 18095",
    d: "M2750.565,425.42a2.3,2.3,0,0,0-2.025-.451,1,1,0,0,0-.731,1.038l.17,2.365,2.569.279S2752.149,426.57,2750.565,425.42ZM2749.4,427.3a.642.642,0,1,1,.654-.629A.642.642,0,0,1,2749.4,427.3Z",
    transform: "translate(-401.868)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17322",
    "data-name": "Group 17322",
    transform: "translate(2346.205 425.179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18096",
    "data-name": "Path 18096",
    d: "M2755.58,435.945a.128.128,0,0,1-.081-.11l-.027-.377a.128.128,0,0,1,.254-.018l.027.377a.128.128,0,0,1-.173.128Zm-.053-.738a.127.127,0,0,1-.081-.11l-.021-.286a1.021,1.021,0,0,1,.745-1.056,1.989,1.989,0,0,1,.973-.021.128.128,0,1,1-.056.249,1.736,1.736,0,0,0-.849.018.765.765,0,0,0-.558.792l.021.286a.128.128,0,0,1-.174.128Z",
    transform: "translate(-2755.423 -433.684)",
    fill: "#bdd0fb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18097",
    "data-name": "Path 18097",
    d: "M2643.855,520.455l.023-1.187a.724.724,0,0,1,.763-.709l8.177.442a.7.7,0,0,1,.666.675l.046,1.142Z",
    transform: "translate(-301.28 -90.627)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18098",
    "data-name": "Path 18098",
    d: "M2726.346,529.687h0l-.352-.007a.069.069,0,0,1-.067-.07.071.071,0,0,1,.07-.067l.352.007a.068.068,0,0,1,0,.137Z",
    transform: "translate(-380.627 -101.256)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18099",
    "data-name": "Path 18099",
    d: "M2653.931,528.041a.128.128,0,0,1-.081-.121l.01-.48a.739.739,0,0,1,.752-.724l1.294.026a.128.128,0,0,1-.005.255l-1.293-.026a.484.484,0,0,0-.493.474l-.009.48a.128.128,0,0,1-.13.125A.13.13,0,0,1,2653.931,528.041Z",
    transform: "translate(-310.834 -98.52)",
    fill: "#bdd0fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18100",
    "data-name": "Path 18100",
    d: "M2540.2,562.106l13.509.282a1.02,1.02,0,0,1,.968.9l.01.07a.892.892,0,0,1-.865,1.045l-13.859-.289a.578.578,0,0,1-.545-.63l.042-.656A.746.746,0,0,1,2540.2,562.106Z",
    transform: "translate(-199.768 -132.762)",
    fill: "#108757"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17327",
    "data-name": "Group 17327",
    transform: "translate(2337.445 431.836)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17323",
    "data-name": "Group 17323",
    transform: "translate(1.394 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148963",
    "data-name": "Rectangle 148963",
    width: 17.728,
    height: 0.89,
    rx: 0.445,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148964",
    "data-name": "Rectangle 148964",
    width: 17.728,
    height: 0.89,
    rx: 0.445,
    transform: "translate(0 1.574)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17324",
    "data-name": "Group 17324",
    transform: "translate(0 4.449)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18101",
    "data-name": "Path 18101",
    d: "M2492.435,816.7c0,.233-.245.411-.548.411H2485.8c-.3,0-.548-.178-.548-.411h0c0-.233.245-.411.548-.411h6.092c.3,0,.548.178.548.411Z",
    transform: "translate(-2485.248 -816.286)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18102",
    "data-name": "Path 18102",
    d: "M2576.886,875.778c0,.217-.245.376-.548.376h-6.092c-.3,0-.548-.159-.548-.376h0c0-.217.245-.376.548-.376h6.092c.3,0,.548.159.548.376Z",
    transform: "translate(-2566.961 -873.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18103",
    "data-name": "Path 18103",
    d: "M2576.886,920.116c0,.217-.245.376-.548.376h-6.092c-.3,0-.548-.159-.548-.376h0c0-.217.245-.377.548-.377h6.092c.3,0,.548.159.548.377Z",
    transform: "translate(-2566.961 -916.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18104",
    "data-name": "Path 18104",
    d: "M2576.886,966.564c0,.217-.245.376-.548.376h-6.092c-.3,0-.548-.159-.548-.376h0c0-.217.245-.377.548-.377h6.092c.3,0,.548.159.548.377Z",
    transform: "translate(-2566.961 -961.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18105",
    "data-name": "Path 18105",
    d: "M2976.326,875.778a.376.376,0,0,1-.376.376H2974.1a.376.376,0,0,1-.376-.376h0a.376.376,0,0,1,.376-.376h1.848a.376.376,0,0,1,.376.376Z",
    transform: "translate(-2957.889 -873.485)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18106",
    "data-name": "Path 18106",
    d: "M2976.326,920.116a.376.376,0,0,1-.376.376H2974.1a.376.376,0,0,1-.376-.376h0a.376.376,0,0,1,.376-.377h1.848a.376.376,0,0,1,.376.377Z",
    transform: "translate(-2957.889 -916.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18107",
    "data-name": "Path 18107",
    d: "M2976.326,966.564a.376.376,0,0,1-.376.376H2974.1a.376.376,0,0,1-.376-.376h0a.376.376,0,0,1,.376-.377h1.848a.376.376,0,0,1,.376.377Z",
    transform: "translate(-2957.889 -961.327)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18108",
    "data-name": "Path 18108",
    d: "M2785.328,1036a.137.137,0,0,1-.137.137H2775.4a.137.137,0,0,1-.137-.137h0a.137.137,0,0,1,.137-.137h9.788a.137.137,0,0,1,.137.137Z",
    transform: "translate(-2765.864 -1028.74)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17325",
    "data-name": "Group 17325",
    transform: "translate(0 13.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18109",
    "data-name": "Path 18109",
    d: "M2492.435,1099.608c0,.233-.245.411-.548.411H2485.8c-.3,0-.548-.178-.548-.411h0c0-.233.245-.411.548-.411h6.092c.3,0,.548.177.548.411Z",
    transform: "translate(-2485.248 -1099.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18110",
    "data-name": "Path 18110",
    d: "M2576.886,1158.688c0,.218-.245.376-.548.376h-6.092c-.3,0-.548-.159-.548-.376h0c0-.217.245-.376.548-.376h6.092c.3,0,.548.159.548.376Z",
    transform: "translate(-2566.961 -1156.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18111",
    "data-name": "Path 18111",
    d: "M2576.886,1203.026c0,.217-.245.376-.548.376h-6.092c-.3,0-.548-.159-.548-.376h0c0-.218.245-.377.548-.377h6.092c.3,0,.548.159.548.377Z",
    transform: "translate(-2566.961 -1199.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18112",
    "data-name": "Path 18112",
    d: "M2576.886,1249.474c0,.217-.245.376-.548.376h-6.092c-.3,0-.548-.159-.548-.376h0c0-.217.245-.376.548-.376h6.092c.3,0,.548.159.548.376Z",
    transform: "translate(-2566.961 -1244.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18113",
    "data-name": "Path 18113",
    d: "M2976.326,1158.688a.376.376,0,0,1-.376.376H2974.1a.376.376,0,0,1-.376-.376h0a.376.376,0,0,1,.376-.376h1.848a.376.376,0,0,1,.376.376Z",
    transform: "translate(-2957.889 -1156.396)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18114",
    "data-name": "Path 18114",
    d: "M2976.326,1203.026a.376.376,0,0,1-.376.376H2974.1a.376.376,0,0,1-.376-.376h0a.376.376,0,0,1,.376-.377h1.848a.376.376,0,0,1,.376.377Z",
    transform: "translate(-2957.889 -1199.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18115",
    "data-name": "Path 18115",
    d: "M2976.326,1249.474a.376.376,0,0,1-.376.376H2974.1a.376.376,0,0,1-.376-.376h0a.376.376,0,0,1,.376-.376h1.848a.376.376,0,0,1,.376.376Z",
    transform: "translate(-2957.889 -1244.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18116",
    "data-name": "Path 18116",
    d: "M2785.328,1318.906a.137.137,0,0,1-.137.137H2775.4a.137.137,0,0,1-.137-.137h0a.137.137,0,0,1,.137-.137h9.788a.137.137,0,0,1,.137.137Z",
    transform: "translate(-2765.864 -1311.651)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17326",
    "data-name": "Group 17326",
    transform: "translate(0 22.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18117",
    "data-name": "Path 18117",
    d: "M2492.435,1378.295c0,.233-.245.411-.548.411H2485.8c-.3,0-.548-.178-.548-.411h0c0-.233.245-.411.548-.411h6.092c.3,0,.548.178.548.411Z",
    transform: "translate(-2485.248 -1377.884)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18118",
    "data-name": "Path 18118",
    d: "M2576.886,1437.376c0,.218-.245.377-.548.377h-6.092c-.3,0-.548-.159-.548-.377h0c0-.217.245-.376.548-.376h6.092c.3,0,.548.159.548.376Z",
    transform: "translate(-2566.961 -1435.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18119",
    "data-name": "Path 18119",
    d: "M2576.886,1481.713c0,.217-.245.377-.548.377h-6.092c-.3,0-.548-.159-.548-.377h0c0-.217.245-.376.548-.376h6.092c.3,0,.548.159.548.376Z",
    transform: "translate(-2566.961 -1477.982)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18120",
    "data-name": "Path 18120",
    d: "M2576.886,1528.161c0,.217-.245.376-.548.376h-6.092c-.3,0-.548-.159-.548-.376h0c0-.217.245-.376.548-.376h6.092c.3,0,.548.159.548.376Z",
    transform: "translate(-2566.961 -1522.924)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18121",
    "data-name": "Path 18121",
    d: "M2976.326,1441.6a.376.376,0,0,1-.376.376H2974.1a.376.376,0,0,1-.376-.376h0a.376.376,0,0,1,.376-.376h1.848a.376.376,0,0,1,.376.376Z",
    transform: "translate(-2957.889 -1439.169)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18122",
    "data-name": "Path 18122",
    d: "M2976.326,1485.936a.377.377,0,0,1-.376.376H2974.1a.377.377,0,0,1-.376-.376h0a.376.376,0,0,1,.376-.376h1.848a.376.376,0,0,1,.376.376Z",
    transform: "translate(-2957.889 -1482.068)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18123",
    "data-name": "Path 18123",
    d: "M2976.326,1532.384a.376.376,0,0,1-.376.376H2974.1a.376.376,0,0,1-.376-.376h0a.376.376,0,0,1,.376-.376h1.848a.376.376,0,0,1,.376.376Z",
    transform: "translate(-2957.889 -1527.01)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18124",
    "data-name": "Path 18124",
    d: "M2785.328,1601.816a.137.137,0,0,1-.137.137H2775.4a.137.137,0,0,1-.137-.137h0a.137.137,0,0,1,.137-.137h9.788a.137.137,0,0,1,.137.137Z",
    transform: "translate(-2765.864 -1594.424)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockGroup);
export default __webpack_public_path__ + "static/media/StockGroup.a6d8328340c7456c0bd703846dc4a2bc.svg";
export { ForwardRef as ReactComponent };